package waldo.sankan.lineamunicipalkmp.web.screens


import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.scope
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import waldo.sankan.lineamunicipalkmp.model.Incidencia
import waldo.sankan.lineamunicipalkmp.web.components.FilterDropdown
import waldo.sankan.lineamunicipalkmp.web.screens.GestionPatrullasScreen
import kotlin.js.Date
import waldo.sankan.lineamunicipalkmp.web.screens.DroneDetailScreen
import kotlinx.browser.window

// ========================================================================
// === SECCIÓN DE FUNCIONES DE UTILIDAD ===
// ========================================================================

private fun formatTimestampWithTime(timestamp: Any?): String {
    val longTime = when (timestamp) {
        is Long -> timestamp
        is Double -> timestamp.toLong()
        is String -> timestamp.toLongOrNull()
        else -> null
    } ?: return "N/A"

    val date = Date(longTime)
    val dia = date.getDate().toString().padStart(2, '0')
    val mes = (date.getMonth() + 1).toString().padStart(2, '0')
    val anio = date.getFullYear()
    val hora = date.getHours().toString().padStart(2, '0')
    val minutos = date.getMinutes().toString().padStart(2, '0')
    return "$dia/$mes/$anio $hora:$minutos"
}

private fun formatDuration(ms: Long?): String {
    if (ms == null || ms < 0) return "N/A"
    val totalSegundos = ms / 1000
    val dias = totalSegundos / (60 * 60 * 24)
    val hCalc = (totalSegundos / (60 * 60)) % 24
    val mCalc = (totalSegundos / 60) % 60
    val parts = mutableListOf<String>()
    if (dias > 0) parts.add("$dias d")
    if (hCalc > 0) parts.add("$hCalc h")
    if (mCalc > 0) parts.add("$mCalc min")
    return if (parts.isEmpty()) "Menos de 1 min" else parts.joinToString(" ")
}

// ========================================================================
// === PANTALLA PRINCIPAL DEL PANEL DE ADMINISTRACIÓN ===
// ========================================================================
@Composable
fun AdminPanelScreen(viewModel: AdminPanelViewModel, onLogout: () -> Unit) {
    val uiState by viewModel.uiState.collectAsState()
    val incidenciasFiltradas by viewModel.incidenciasFiltradas.collectAsState()

    Div({
        style {
            padding(20.px)
            fontFamily("sans-serif")
            backgroundColor(Color("#F5F7FB"))
            minHeight(100.vh)
        }
    }) {
        val rol = (uiState.rolAdmin?.rol ?: "").uppercase().trim()
        val esEjecutivo = rol == "GENERAL" || rol == "COMUNAL" || rol == "DIRECCION_DAO" || rol.contains("ADMIN") || rol.contains("ALCALDE") || rol.isEmpty()

        // --- 📢 MANDO CENTRAL: BANNER DE AVISO NACIONAL ---
        if (uiState.avisoNacional != null && uiState.avisoNacional.activo == true) {
            Div({
                style {
                    backgroundColor(Color("#FFEBEE")); color(Color("#B71C1C"))
                    padding(12.px); borderRadius(8.px); marginBottom(16.px)
                    display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween)
                    alignItems(AlignItems.Center); border(1.px, LineStyle.Solid, Color("#EF9A9A"))
                }
            }) {
                Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px) } }) {
                    Span({ style { fontSize(20.px) } }) { Text("📢") }
                    Div {
                        B { Text(uiState.avisoNacional.titulo as String) }
                        P({ style { margin(0.px); fontSize(14.px) } }) { Text(uiState.avisoNacional.contenido as String) }
                    }
                }
                if (rol == "GENERAL") {
                    Button(attrs = {
                        onClick { viewModel.desactivarAvisoNacional() }
                        style {
                            padding(6.px, 12.px); backgroundColor(Color("#B71C1C")); color(Color.white)
                            border(0.px); borderRadius(4.px); cursor("pointer"); fontSize(12.px)
                        }
                    }) { Text("QUITAR AVISO") }
                } else {
                    Button(attrs = {
                        onClick { viewModel.onShowGestionServiciosClicked() }
                        style {
                            padding(6.px, 12.px); backgroundColor(Color("#1976D2")); color(Color.white)
                            border(0.px); borderRadius(4.px); cursor("pointer"); fontSize(12.px)
                        }
                    }) { Text("IR A SINCRONIZAR") }
                }
            }
        }

        when {
            uiState.showGestionServiciosView -> GestionServiciosScreen(viewModel = viewModel, onBack = { viewModel.onGestionServiciosBackClicked() })
            uiState.showGestionGabineteView -> GestionGabineteScreen(viewModel = viewModel, onBack = { viewModel.onGestionGabineteBackClicked() })
            uiState.showGestionPatrullasView -> GestionPatrullasScreen(
                viewModel = viewModel, 
                tipoIncidenciaAsignadaRef = uiState.patrullaContextoRef, 
                tipoIncidenciaAsignadaDisplayName = uiState.patrullaContextoDisplayName
            )
            uiState.showGestionDelitosView -> GestionDelitosScreen(viewModel = viewModel, onBack = { viewModel.onGestionDelitosBackClicked() })
            uiState.showGestionComunasView -> GestionComunasScreen(viewModel = viewModel, onBack = { viewModel.onGestionComunasBackClicked() })
            uiState.showIngresoIncidenciaView -> IngresoIncidenciaScreen(viewModel = viewModel, onBack = { viewModel.onIngresoIncidenciaBackClicked() })
            uiState.showDroneView -> {
                val selectedDron = uiState.selectedIncidenciaDron
                if (selectedDron != null) {
                    key(selectedDron) {
                        DroneDetailScreen(
                            incidencia = selectedDron,
                            viewModel = viewModel,
                            uiState = uiState,
                            onBack = { viewModel.onDroneIncidenciaSelected(null) },
                            mensajeParaAdmin = uiState.mensajeParaAdmin,
                            onMensajeParaAdminChanged = viewModel::onMensajeParaAdminChanged,
                            onEnviarMensajeAlAdmin = { viewModel.enviarMensajeAlAdmin(selectedDron.id) }
                        )
                    }
                } else {
                    DroneVerificationScreen(viewModel = viewModel, onBack = { viewModel.onDroneViewBackClicked() })
                }
            }
            uiState.showInformeView -> {
                if (uiState.selectedIncidencia != null) {
                    val selected = uiState.selectedIncidencia!!
                    IncidenciaDetailScreen(
                        incidencia = selected,
                        rolAdmin = uiState.rolAdmin,
                        viewModel = viewModel,
                        onBackToPanel = { viewModel.onIncidenciaSelected(null) },
                        onBackToInforme = { viewModel.onIncidenciaSelected(null) },
                        onEstadoChange = { newState, file -> viewModel.changeIncidenciaStatus(selected.id, newState, file) },
                        mensajeParaCiudadano = uiState.mensajeParaCiudadano,
                        onMensajeParaCiudadanoChanged = viewModel::onMensajeParaCiudadanoChanged,
                        onEnviarMensajeCiudadano = { viewModel.enviarMensajeAlCiudadano(selected.id) },
                        mensajeParaSolucionador = uiState.mensajeParaSolucionador,
                        onMensajeParaSolucionadorChanged = viewModel::onMensajeParaSolucionadorChanged,
                        onEnviarMensajeSolucionador = { viewModel.enviarMensajeAlSolucionador(selected.id) },
                        uiState = uiState,
                        mensajeParaDron = uiState.mensajeParaDron,
                        onMensajeParaDronChanged = viewModel::onMensajeParaDronChanged,
                        onEnviarMensajeAlDron = { viewModel.enviarMensajeAlDron(selected.id) },
                        mensajeParaAdmin = uiState.mensajeParaAdmin,
                        onMensajeParaAdminChanged = viewModel::onMensajeParaAdminChanged,
                        onEnviarMensajeAlAdmin = { viewModel.enviarMensajeAlAdmin(selected.id) }
                    )
                } else {
                    InformeScreen(viewModel = viewModel, onBack = { viewModel.onInformeBackClicked() })
                }
            }
            uiState.showEstadisticasView -> EstadisticasWebScreen(viewModel = viewModel, onBack = { viewModel.onEstadisticasBackClicked() })
            uiState.showEstadisticasSeguridadView -> {
                if (uiState.estadisticasDelitos != null) {
                    EstadisticasSeguridadScreen(viewModel = viewModel, onBack = { viewModel.onEstadisticasSeguridadBackClicked() })
                }
            }
            uiState.showDashboardSeguridadView -> DashboardSeguridadScreen(uiState = uiState, viewModel = viewModel, onBack = { viewModel.onDashboardSeguridadBackClicked() })
            uiState.showNoticiasView -> NoticiasScreen(viewModel = viewModel, onBack = { viewModel.onNoticiasBackClicked() })
            uiState.showInformeSeguridadView -> {
                if (uiState.selectedIncidencia != null) {
                    val selected = uiState.selectedIncidencia!!
                    IncidenciaDetailScreen(
                        incidencia = selected,
                        rolAdmin = uiState.rolAdmin,
                        viewModel = viewModel,
                        onBackToPanel = { viewModel.onIncidenciaSelected(null) },
                        onBackToInforme = { viewModel.onIncidenciaSelected(null) },
                        onEstadoChange = { newState, file -> viewModel.changeIncidenciaStatus(selected.id, newState, file) },
                        mensajeParaCiudadano = uiState.mensajeParaCiudadano,
                        onMensajeParaCiudadanoChanged = viewModel::onMensajeParaCiudadanoChanged,
                        onEnviarMensajeCiudadano = { viewModel.enviarMensajeAlCiudadano(selected.id) },
                        mensajeParaSolucionador = uiState.mensajeParaSolucionador,
                        onMensajeParaSolucionadorChanged = viewModel::onMensajeParaSolucionadorChanged,
                        onEnviarMensajeSolucionador = { viewModel.enviarMensajeAlSolucionador(selected.id) },
                        uiState = uiState,
                        mensajeParaDron = uiState.mensajeParaDron,
                        onMensajeParaDronChanged = viewModel::onMensajeParaDronChanged,
                        onEnviarMensajeAlDron = { viewModel.enviarMensajeAlDron(selected.id) },
                        mensajeParaAdmin = uiState.mensajeParaAdmin,
                        onMensajeParaAdminChanged = viewModel::onMensajeParaAdminChanged,
                        onEnviarMensajeAlAdmin = { viewModel.enviarMensajeAlAdmin(selected.id) }
                    )
                } else {
                    InformeSeguridadScreen(onBack = { viewModel.onInformeSeguridadBackClicked() }, viewModel = viewModel)
                }
            }
            uiState.showMapView -> MapScreen(viewModel = viewModel, onBack = { viewModel.onMapBackClicked() })
            uiState.selectedIncidencia != null -> {
                val selected = uiState.selectedIncidencia!!
                IncidenciaDetailScreen(
                    incidencia = selected,
                    rolAdmin = uiState.rolAdmin,
                    viewModel = viewModel,
                    onBackToPanel = { viewModel.onIncidenciaSelected(null) },
                    onBackToInforme = { viewModel.onShowInformeClicked() },
                    onEstadoChange = { newState, file -> viewModel.changeIncidenciaStatus(selected.id, newState, file) },
                    mensajeParaCiudadano = uiState.mensajeParaCiudadano,
                    onMensajeParaCiudadanoChanged = viewModel::onMensajeParaCiudadanoChanged,
                    onEnviarMensajeCiudadano = { viewModel.enviarMensajeAlCiudadano(selected.id) },
                    mensajeParaSolucionador = uiState.mensajeParaSolucionador,
                    onMensajeParaSolucionadorChanged = viewModel::onMensajeParaSolucionadorChanged,
                    onEnviarMensajeSolucionador = { viewModel.enviarMensajeAlSolucionador(selected.id) },
                    uiState = uiState,
                    mensajeParaDron = uiState.mensajeParaDron,
                    onMensajeParaDronChanged = viewModel::onMensajeParaDronChanged,
                    onEnviarMensajeAlDron = { viewModel.enviarMensajeAlDron(selected.id) },
                    mensajeParaAdmin = uiState.mensajeParaAdmin,
                    onMensajeParaAdminChanged = viewModel::onMensajeParaAdminChanged,
                    onEnviarMensajeAlAdmin = { viewModel.enviarMensajeAlAdmin(selected.id) }
                )
            }
            else -> {
                // --- CONTENEDOR PRINCIPAL BLINDADO ---
                Div({
                    style {
                        height(95.vh)
                        backgroundColor(Color("#1976D2"))
                        borderRadius(12.px)
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        property("overflow-y", "auto")
                    }
                }) {
                    // --- CABECERA DE GALA ---
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            property("border-bottom", "2px solid #1565C0")
                        }
                    }) {
                        Div({
                            style {
                                width(15.percent); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center)
                                alignItems(AlignItems.Center); padding(24.px); boxSizing("border-box")
                            }
                        }) {
                            Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(8.px) } }) {
                                Img(src = "logo_icon.svg", attrs = { style { height(120.px) } })
                                H2({ style { fontSize(24.px); color(Color.white); margin(0.px); property("text-shadow", "1px 1px 2px rgba(0,0,0,0.4)") } }) {
                                    Span({ style { fontWeight("normal") } }) { Text("Linea") }
                                    Span({ style { fontWeight("bold") } }) { Text("Muni") }
                                }
                                P(attrs = { attr("translate", "no"); style { fontSize(16.px); color(Color("#FB8C00")); fontWeight("bold"); letterSpacing(1.px); margin(0.px) } }) { Text("SMART CITY") }
                            }
                        }

                        Div({
                            style {
                                width(85.percent); padding(16.px, 24.px); boxSizing("border-box")
                                display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(16.px)
                            }
                        }) {
                            val panelTitle = if (rol == "GENERAL") "PANEL DE CONTROL GENERAL" 
                                             else "PANEL DE CONTROL: ${uiState.rolAdmin?.comunaAsignadaDisplayName?.uppercase() ?: "COMUNAL"}"
                            H1({
                                style {
                                    color(Color.white); fontSize(32.px); fontWeight(700); flex(1);
                                    textAlign("center"); margin(0.px); paddingTop(20.px)
                                }
                            }) { Text(panelTitle) }

                            // BARRA DE FILTROS Y ACCIONES
                            Div({
                                style {
                                    display(DisplayStyle.Flex)
                                    flexDirection(FlexDirection.Column)
                                    gap(16.px)
                                    backgroundColor(Color.white)
                                    padding(12.px, 16.px) // 🛡️ RECORTE TÁCTICO: Menos padding para ganar espacio
                                    borderRadius(12.px)
                                    property("box-shadow", "0 4px 6px rgba(0,0,0,0.05)")
                                    marginBottom(24.px)
                                    boxSizing("border-box")
                                }
                            }) {
                                // Fila de Filtros
                                Div({ style { display(DisplayStyle.Flex); gap(8.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
                                    FilterDropdown(
                                        label = "Mes:",
                                        selectedValue = uiState.filtroMes,
                                        options = uiState.mesesDisponibles,
                                        onValueChanged = { viewModel.onFiltroMesChanged(it) },
                                        optionDisplayNames = uiState.mesesDisponibles.associateWith {
                                            val parts = it.split("-")
                                            val year = parts[0].toInt()
                                            val month = parts[1].toInt()
                                            Date(year, month - 1).toLocaleString("es-CL", options = js("{'month': 'long', 'year': 'numeric'}")).capitalize()
                                        }
                                    )
                                    if (rol == "GENERAL") {
                                        FilterDropdown(
                                            label = "Regi\u00F3n:",
                                            selectedValue = uiState.filtroRegion,
                                            options = uiState.regiones.map { it.nombre },
                                            onValueChanged = { viewModel.onFiltroRegionChanged(it) }
                                        )
                                        FilterDropdown(
                                            label = "Comuna:",
                                            selectedValue = uiState.filtroComuna,
                                            options = if (uiState.filtroRegion != null) {
                                                uiState.comunas.filter { it.regionDisplayName == uiState.filtroRegion }.map { it.comunaDisplayName }
                                            } else {
                                                uiState.comunas.map { it.comunaDisplayName }.distinct()
                                            },
                                            onValueChanged = { viewModel.onFiltroComunaChanged(it) }
                                        )
                                    }

                                    if (rol == "GENERAL" || rol == "COMUNAL" || rol == "OPERADORA" || rol == "OPERADOR_DRON" || rol == "DIRECCION_DAO") {
                                        FilterDropdown(
                                            label = "Tipo Incidencia:",
                                            selectedValue = uiState.filtroTipo,
                                            options = uiState.tiposIncidencia.map { it.nombreDisplay ?: it.nombre }.distinct().sorted(),
                                            onValueChanged = { viewModel.onFiltroTipoChanged(it) }
                                        )
                                    }
                                    FilterDropdown(
                                        label = "Estado:",
                                        selectedValue = uiState.filtroEstado,
                                        options = listOf("EN_PROCESO", "SOLUCIONADO", "RECHAZADO", "VERIFICADO"),
                                        onValueChanged = { viewModel.onFiltroEstadoChanged(it) }
                                    )
                                    FilterDropdown(
                                        label = "Orden:",
                                        selectedValue = uiState.ordenPorFecha,
                                        options = listOf("Recientes", "Antiguas"),
                                        onValueChanged = { it?.let { viewModel.onOrdenChanged(it) } },
                                        isNullable = false
                                    )
                                }

                                // --- FILA DE BOTONES DE ACCIÓN (BLINDADA POR RANGO) ---
                                Div({ style { display(DisplayStyle.Flex); gap(10.px); flexWrap(FlexWrap.Wrap); property("border-top", "1px solid #EEE"); paddingTop(16.px) } }) {
                                    
                                    ActionButton("+ Incidencia", Color("#34A853")) { viewModel.onShowIngresoIncidenciaClicked() }
                                    ActionButton("Mapa", Color("#1A73E8")) { viewModel.onShowMapClicked() }
                                    ActionButton("\uD83D\uDDFA\uFE0F Plan Cuadrante", Color("#1A73E8")) { viewModel.onShowPlanCuadranteModal() }

                                    // --- \uD83D\uDEE1\uFE0F L\u00D3GICA DE MANDO UNIFICADA ---
                                    when {
                                        rol == "OPERADORA" -> {
                                            ActionButton("Patrullas", Color("#6A1B9A")) { viewModel.onShowGestionPatrullasClicked(contextoRef = "TODOS", contextoDisplayName = "TODAS") }
                                       }
                                        rol == "SEGURIDAD_ADMIN" -> {
                                            ActionButton("Patrullas", Color("#6A1B9A")) { viewModel.onShowGestionPatrullasClicked(contextoRef = "TODOS", contextoDisplayName = "Seguridad Ciudadana") }
                                            ActionButton("Tipificaciones", Color("#AD1457")) { viewModel.onShowGestionDelitosClicked() }
                                            ActionButton("Estad\u00EDsticas Seg.", Color("#AD1457")) { viewModel.onShowEstadisticasSeguridadClicked() }
                                            ActionButton("\u00CDndices KPIs", Color("#AD1457")) { viewModel.onShowDashboardSeguridadClicked() }
                                        }
                                        rol == "GENERAL" || rol == "COMUNAL" -> {
                                            if (rol == "GENERAL") {
                                                ActionButton("Comunas", Color("#00ACC1")) { viewModel.onShowGestionComunasClicked() }
                                            } else {
                                                ActionButton("Patrullas/Sectores", Color("#6A1B9A")) { viewModel.onShowGestionPatrullasClicked(contextoRef = "TODOS", contextoDisplayName = "TODAS") }
                                                ActionButton("\uD83D\uDCBC Gabinete", Color("#455A64")) { viewModel.onShowGestionGabineteClicked() }
                                            }
                                            ActionButton("Servicios", Color("#FB8C00")) { viewModel.onShowGestionServiciosClicked() }
                                            ActionButton("Tipificaciones", Color("#AD1457")) { viewModel.onShowGestionDelitosClicked() }
                                            ActionButton("Estad\u00EDsticas", Color("#1A73E8")) { viewModel.onShowEstadisticasClicked() }
                                            ActionButton("\uD83D\uDCE2 Noticias", Color("#6A1B9A")) { viewModel.onShowNoticiasClicked() }
                                        }
                                        rol == "DIRECCION_DAO"-> {
                                            ActionButton("Servicios", Color("#FB8C00")) { viewModel.onShowGestionServiciosClicked() }
                                            ActionButton("Patrullas", Color("#6A1B9A")) { viewModel.onShowGestionPatrullasClicked(contextoRef = "TODOS", contextoDisplayName = "DIRECCI\u00D3N DAO") }
                                            ActionButton("Tipificaciones", Color("#AD1457")) { viewModel.onShowGestionDelitosClicked() }
                                            ActionButton("Estad\u00EDsticas", Color("#1A73E8")) { viewModel.onShowEstadisticasClicked() }
                                        }
                                        rol in listOf("ASEO", "BASURA", "ILUMINACION", "BACHE", "SEMAFORO", "AUTO_ABANDONADO", "SALVAVIDAS", "SOCIAL_ADMIN", "SEGURIDAD_ADULTO_MAYOR", "EMERGENCIA_CARRETERA") -> {
                                            val miRef = uiState.rolAdmin?.uidRol ?: ""
                                            val miNombre = uiState.rolAdmin?.nombre ?: ""
                                            ActionButton("Patrullas", Color("#6A1B9A")) { viewModel.onShowGestionPatrullasClicked(contextoRef = miRef, contextoDisplayName = miNombre) }
                                            ActionButton("Tipificaciones", Color("#AD1457")) { viewModel.onShowGestionDelitosClicked() }
                                            ActionButton("Estad\u00EDsticas", Color("#AD1457")) { viewModel.onShowEstadisticasSeguridadClicked() }
                                       }
                                    }

                                    ActionButton("\uD83D\uDCCA Exportar", Color("#00897B")) { viewModel.exportarIncidenciasCSV() }

                                    Div({ style { flex(1) } }) 

                                    Button(attrs = {
                                        onClick { onLogout() }
                                        style {
                                            padding(8.px, 20.px); fontSize(14.px); fontWeight("bold")
                                            color(Color.white); backgroundColor(Color("#FB8C00"))
                                            borderRadius(6.px); border(0.px); cursor("pointer")
                                        }
                                    }) { Text("Cerrar Sesi\u00F3n") }
                                }
                            }
                        }
                    }

                    // --- CUERPO DEL PANEL (TABLA ALINEADA) ---
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            width(100.percent)
                        }
                    }) {
                        Div({
                            style {
                                width(100.percent)
                                padding(0.px, 24.px, 40.px, 24.px) 
                                boxSizing("border-box")
                            }
                        }) {
                            Div({
                                style {
                                    backgroundColor(Color.white)
                                    padding(24.px)
                                    borderRadius(12.px)
                                    property("box-shadow", "0 4px 6px rgba(0,0,0,0.05)")
                                    boxSizing("border-box")
                                }
                            }) {
                                if (uiState.isLoading) {
                                    Div({ style { textAlign("center"); padding(40.px) } }) { Text("Cargando inteligencia de campo...") }
                                } else if (uiState.error != null) {
                                    Div({ style { color(Color.red); textAlign("center") } }) { Text("Error: ${uiState.error}") }
                                } else {
                                    IncidentsTable(incidenciasFiltradas, onIncidenciaClick = { viewModel.onIncidenciaSelected(it) }, viewModel = viewModel, esEjecutivo = esEjecutivo)
                                }
                            }
                        }
                    }
                }
            }
        }

        // --- \uD83D\uDDBC\uFE0F MODAL VISOR DEL PLANO CUADRANTE (GLOBAL) ---
        if (uiState.showPlanCuadranteModal) {
            Div({
                style {
                    position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh)
                    backgroundColor(Color("rgba(0,0,0,0.8)")); display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.Center); alignItems(AlignItems.Center); property("z-index", "2000")
                }
                onClick { viewModel.onHidePlanCuadranteModal() }
            }) {
                Div({
                    style {
                        backgroundColor(Color.white); padding(12.px); borderRadius(12.px)
                        maxWidth(90.percent); maxHeight(90.percent); position(Position.Relative)
                    }
                    onClick { it.stopPropagation() }
                }) {
                    Button(attrs = {
                        onClick { viewModel.onHidePlanCuadranteModal() }
                        style {
                            position(Position.Absolute); top((-15).px); right((-15).px)
                            width(35.px); height(35.px); borderRadius(50.percent)
                            backgroundColor(Color.red); color(Color.white); fontWeight("bold")
                            cursor("pointer"); border(2.px, LineStyle.Solid, Color.white)
                        }
                    }) { Text("X") }

                    val currentComunaName = uiState.filtroComuna ?: uiState.rolAdmin?.comunaAsignadaDisplayName ?: "Arica"
                    val imageName = if (currentComunaName.contains("Arica", ignoreCase = true)) "sectoresarica.png"
                                    else "sectores${currentComunaName.lowercase().replace(" ", "")}.png"

                    Img(src = imageName, attrs = {
                        style { maxWidth(100.percent); maxHeight(80.vh); borderRadius(8.px) }
                    })
                    H3({ style { textAlign("center"); margin(12.px, 0.px); color(Color.black) } }) { Text("Planimetr\u00EDa Territorial: $currentComunaName") }
                }
            }
        }

        // --- 👥 MODAL DE REPORTES DUPLICADOS / ASOCIADOS ---
        if (uiState.showDuplicadosModal) {
            Div({
                style {
                    position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh)
                    backgroundColor(Color("rgba(0,0,0,0.6)")); property("z-index", "1000")
                    display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
                }
            }) {
                Div({
                    style {
                        backgroundColor(Color.white); padding(24.px); borderRadius(12.px)
                        maxWidth(900.px); width(90.percent); maxHeight(80.vh); property("overflow-y", "auto")
                        property("box-shadow", "0 4px 20px rgba(0,0,0,0.3)")
                    }
                }) {
                    Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); marginBottom(16.px) } }) {
                        H3({ style { margin(0.px); color(Color("#1976D2")) } }) { Text("👥 Reportes Ciudadanos Agrupados (Recurrencia)") }
                        Button(attrs = {
                            onClick { viewModel.cerrarModalDuplicados() }
                            style { padding(6.px, 12.px); backgroundColor(Color("#D32F2F")); color(Color.white); border(0.px); borderRadius(6.px); cursor("pointer") }
                        }) { Text("Cerrar") }
                    }

                    P({ style { fontSize(14.px); color(Color("#555")); marginBottom(16.px) } }) {
                        Text("Listado de reportes individuales presentados por vecinos para este mismo problema en las inmediaciones:")
                    }

                    Table({ style { width(100.percent); property("border-collapse", "collapse") } }) {
                        Thead {
                            Tr({ style { backgroundColor(Color("#1976D2")); color(Color.white) } }) {
                                listOf("ID", "Ciudadano", "Fecha", "Descripción", "Acción").forEach {
                                    Th({ style { padding(10.px); textAlign("left") } }) { Text(it) }
                                }
                            }
                        }
                        Tbody {
                            uiState.listaDuplicadosModal.forEach { dup ->
                                Tr({ style { property("border-bottom", "1px solid #EEE") } }) {
                                    Td({ style { padding(10.px); fontWeight("bold") } }) { Text(dup.id.take(8)) }
                                    Td({ style { padding(10.px) } }) { Text(dup.usuarioNombre ?: "Ciudadano") }
                                    Td({ style { padding(10.px) } }) { Text(formatTimestampWithTime(dup.fechaCreacion)) }
                                    Td({ style { padding(10.px); maxWidth(250.px); property("white-space", "nowrap"); property("overflow", "hidden"); property("text-overflow", "ellipsis") } }) { Text(dup.descripcion) }
                                    Td({ style { padding(10.px); display(DisplayStyle.Flex); gap(8.px) } }) {
                                        Button(attrs = {
                                            onClick { 
                                                viewModel.cerrarModalDuplicados()
                                                viewModel.onIncidenciaSelected(dup) 
                                            }
                                            style { padding(6.px, 12.px); backgroundColor(Color("#1976D2")); color(Color.white); border(0.px); borderRadius(6.px); cursor("pointer") }
                                        }) { Text("Detalles") }

                                        if (dup.marcadoComoDuplicado) {
                                            Button(attrs = {
                                                onClick { 
                                                    viewModel.desvincularIncidencia(dup.id, dup.padreId)
                                                }
                                                style { padding(6.px, 12.px); backgroundColor(Color("#D32F2F")); color(Color.white); border(0.px); borderRadius(6.px); cursor("pointer") }
                                            }) { Text("🔗 Desvincular") }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun ActionButton(label: String, bgColor: CSSColorValue, onClick: () -> Unit) {
    Button(attrs = {
        onClick { onClick() }
        style {
            padding(8.px, 12.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
            backgroundColor(bgColor); borderRadius(8.px); cursor("pointer"); border(1.px, LineStyle.Solid, Color.black)
            property("transition", "all 0.2s ease")
            property("box-shadow", "0 2px 4px rgba(0,0,0,0.1)")
        }
    }) { Text(label) }
}

// ========================================================================
// === TABLA DE INCIDENCIAS (MASTER CON COLORES SEM\u00C1FORO) ===
// ========================================================================

@Composable
fun IncidentsTable(incidencias: List<Incidencia>, onIncidenciaClick: (Incidencia) -> Unit, viewModel: AdminPanelViewModel? = null, esEjecutivo: Boolean = true) {
    Div({ style { marginBottom(16.px); display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center) } }) {
        H3({ style { margin(0.px); color(Color("#333")) } }) { Text("Incidencias Detectadas: ${incidencias.size}") }
    }

    Table({
        style { width(100.percent); property("border-collapse", "collapse"); property("overflow", "hidden"); borderRadius(8.px) }
    }) {
        Thead {
            Tr({ style { backgroundColor(Color("#1976D2")) } }) {
                listOf("ID", "Comuna", "Tipo Incidencia", "Fecha Creaci\u00F3n", "Fecha Soluci\u00F3n", "Tiempo", "Foto", "Obs. Ciudadano", "Estado", "Acci\u00F3n").forEach {
                    Th({ style { padding(16.px); textAlign("left"); fontSize(16.px); color(Color.white); property("border-bottom", "2px solid #EEE") } }) { Text(it) }
                }
            }
        }
        Tbody {
            incidencias.forEach { incidencia ->
                val rowBgColor = when (incidencia.estado.uppercase()) {
                    "SOLUCIONADO" -> "#E8F5E9"
                    "RECHAZADO" -> "#FFEBEE"
                    "EN_PROCESO", "ASIGNADO" -> "#FFF9C4"
                    "VERIFICADO" -> "#E3F2FD"
                    else -> "#FFFFFF"
                }

                key(incidencia.id) {
                    Tr({
                        style {
                            backgroundColor(Color(rowBgColor))
                            property("border-bottom", "1px solid black")
                            property("transition", "background-color 0.2s")
                        }
                    }) {
                        Td({ style { padding(12.px); fontSize(14.px); fontWeight("bold") } }) {
                            Span({
                                style {
                                    backgroundColor(Color("#E3F2FD")); color(Color("#1976D2"))
                                    padding(4.px, 8.px); borderRadius(4.px); cursor("pointer")
                                    border(1.px, LineStyle.Solid, Color("#BBDEFB"))
                                    display(DisplayStyle.InlineBlock)
                                }
                                onClick {
                                    val idShort = incidencia.id.take(8)
                                    window.navigator.clipboard.writeText(idShort)
                                    window.alert("📋 ID '$idShort' copiado al portapapeles")
                                }
                            }) {
                                Text("📋 ${incidencia.id.take(8)}")
                            }
                        }
                        Td({ style { padding(12.px); fontSize(16.px) } }) { Text(incidencia.comunaDisplayName ?: "N/A") }
                        Td({ style { padding(12.px); fontSize(16.px) } }) {
                            Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(4.px) } }) {
                                Text(incidencia.tipoIncidenciaDisplayName ?: "N/A")
                                val hijosCount = viewModel?.contarHijos(incidencia.id) ?: incidencias.count { it.padreId == incidencia.id }
                                if (!incidencia.marcadoComoDuplicado && hijosCount > 0) {
                                    Div({
                                        style {
                                            backgroundColor(Color("#E91E63")); color(Color.white)
                                            padding(2.px, 6.px); borderRadius(4.px); fontSize(11.px); fontWeight("bold")
                                            cursor("pointer"); display(DisplayStyle.InlineBlock)
                                        }
                                        onClick { viewModel?.abrirModalDuplicados(incidencia.id) }
                                    }) {
                                        Text("🔥 Recurrente ($hijosCount)")
                                    }
                                }
                            }
                        }
                        Td({ style { padding(12.px); fontSize(16.px) } }) { Text(formatTimestampWithTime(incidencia.fechaCreacion)) }
                        Td({ style { padding(12.px); fontSize(16.px) } }) { Text(formatTimestampWithTime(incidencia.fechaSolucion)) }
                        Td({ style { padding(12.px); fontSize(16.px) } }) {
                            val creacion = when(val f = incidencia.fechaCreacion) {
                                is Long -> f
                                is Double -> f.toLong()
                                else -> 0L
                            }
                            val solucion = when(val f = incidencia.fechaSolucion) {
                                is Long -> f
                                is Double -> f.toLong()
                                else -> 0L
                            }
                            val duration = if (creacion > 0 && solucion > 0) (solucion - creacion) else null
                            Text(formatDuration(duration))
                        }
                        Td({ style { padding(8.px); textAlign("center") } }) {
                            val fotoUrl = incidencia.urlImagen
                            if (!fotoUrl.isNullOrBlank()) {
                                Img(src = fotoUrl, attrs = {
                                    style {
                                        width(50.px); height(50.px)
                                        borderRadius(6.px); property("object-fit", "cover")
                                        border(1.px, LineStyle.Solid, Color("#ccc"))
                                    }
                                })
                            } else {
                                Span({ style { fontSize(12.px); color(Color.gray) } }) { Text("Sin foto") }
                            }
                        }
                        Td({ style { padding(12.px); fontSize(15.px); color(Color("#555")); maxWidth(200.px); property("white-space", "nowrap"); property("overflow", "hidden"); property("text-overflow", "ellipsis") } }) {
                            Text(incidencia.descripcion)
                        }
                        Td({ style { padding(12.px) } }) { StatusBadge(incidencia.estado) }
                        Td({ style { padding(12.px); display(DisplayStyle.Flex); gap(8.px); alignItems(AlignItems.Center) } }) {
                            Button(attrs = {
                                onClick { onIncidenciaClick(incidencia) }
                                style {
                                    padding(10.px, 18.px); fontSize(16.px); fontWeight("bold"); color(Color.white)
                                    backgroundColor(Color("#1976D2")); borderRadius(8.px); cursor("pointer"); border(1.px, LineStyle.Solid, Color.black)
                                    property("transition", "all 0.2s ease")
                                    property("box-shadow", "0 2px 4px rgba(0,0,0,0.1)")
                                }
                            }) { Text("Detalles") }

                            if (viewModel != null) {
                                Button(attrs = {
                                    onClick { viewModel.vincularIncidenciaManual(incidencia.id) }
                                    style {
                                        padding(10.px, 14.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                                        backgroundColor(Color("#34A853")); borderRadius(8.px); cursor("pointer"); border(1.px, LineStyle.Solid, Color.black)
                                        property("transition", "all 0.2s ease")
                                        property("box-shadow", "0 2px 4px rgba(0,0,0,0.1)")
                                    }
                                }) { Text("🔗 Vincular") }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun StatusBadge(estado: String) {
    val colorHex = when (estado.uppercase()) {
        "SOLUCIONADO" -> "#4CAF50"
        "RECHAZADO" -> "#F44336"
        "EN_PROCESO", "ASIGNADO" -> "#FFC107"
        "VERIFICADO" -> "#3F51B5"
        else -> "#808080"
    }
    val text = when (estado.uppercase()) {
        "SOLUCIONADO" -> "Solucionado"
        "RECHAZADO" -> "Rechazado"
        "EN_PROCESO", "ASIGNADO" -> "En Proceso"
        "VERIFICADO" -> "Verificado"
        else -> estado
    }

    Span({
        style {
            padding(8.px, 12.px);
            fontSize(14.px);
            fontWeight("bold");
            color(Color.white)
            backgroundColor(Color(colorHex));
            borderRadius(20.px);
            border(1.px, LineStyle.Solid, Color.black)
            property("box-shadow", "0 4px 8px rgba(0,0,0,0.1)")
        }
    }) { Text(text) }
}
